import {useMutation} from '@apollo/react-hooks';

import type {
    DeleteTag as DeleteTagMutation,
    DeleteTagVariables as DeleteTagMutationVariables,
    DeleteTagInput,
} from 'nutshell-graphql-types';

import {bustManagedCollectionCache} from '../../../../util/bust-managed-collection-cache';

import DELETE_TAG from '../mutations/delete-tag.graphql';

export function useDeleteTag(): {
    deleteTag: (arg1: DeleteTagInput) => Promise<any>;
    isDeleting: boolean;
} {
    const [deleteTag, {loading}] = useMutation<DeleteTagMutation, DeleteTagMutationVariables>(
        DELETE_TAG
    );

    return {
        deleteTag: (input: DeleteTagInput) =>
            deleteTag({
                variables: {input},
            }).then(() => {
                bustManagedCollectionCache('tags');
            }),
        isDeleting: loading,
    };
}
